import React, { FC, useEffect, useState } from 'react'
import styles from './ClaimTable.module.css'
import ClaimTableHeader from '../ClaimTableHeader/ClaimTableHeader'
import { fillingArray, getDaysInMonth } from '../../utils/date'
import { useNavigate } from 'react-router-dom'
import PATH from '../../navigation/path'
import clockIcon from '../../assets/icons/clock.svg'
import calendarIcon from '../../assets/icons/calendar.svg'
import { ClaimForTableType, ClaimsFromPlacesType } from '../../redux/actions/types'
import { monthsArr } from '../../constants/constants'
import Tooltip from '../UI/Tooltip/Tooltip'
import CustomModal from '../UI/CustomModal/CustomModal'
import CreateClaim from '../CreateClaim/CreateClaim'
import { useAppSelector } from '../../redux/types/types'
import { useDispatch } from 'react-redux'
import { getClients } from '../../redux/actions/clientsAction'
import { getManagers } from '../../redux/actions/clientManagersAction'
import { useMediaQuery } from 'react-responsive'
import { createStyleForStatusTable } from '../../utils/createStatusForClaims'

export type ClaimTablePropsType = {
  fromCurrentPlatform?: boolean
  yearsAndMonth: string
  monthNumber: number
  setMonthNumber: (monthNumber: number) => void
  onOpenClaimFilters: () => void
  onCheckMonthHandler: (month: string, year: string) => void
  claims: any
  onClick?: any
  places?: any
  type?: string | number
  selectPlatfrom?: JSX.Element
}

const ClaimTable: FC<ClaimTablePropsType> = ({
  fromCurrentPlatform,
  yearsAndMonth,
  monthNumber,
  setMonthNumber,
  onOpenClaimFilters,
  claims,
  onCheckMonthHandler,
  places,
  selectPlatfrom,
  type,
}) => {
  const { user, token } = useAppSelector((state) => state.auth)
  const { clients } = useAppSelector((state) => state.clients)
  const [createClaimModal, setCreateClaimModal] = useState(false)
  const [platformName, setPlatformName] = useState<string>('')
  const [platformId, setPlatformId] = useState<number>(-1)
  const [startDate, setStartDate] = useState<any>(null)

  const [platforms, setPlatforms] = useState<ClaimForTableType[]>([])
  const [days, setDays] = useState<number[]>([])

  const [weekMode, setWeekMode] = useState(false)

  const [displayedHover, setDisplayedHover] = React.useState(true)
  const [displayedHoverId, setDisplayedHoverId] = React.useState<number | null>(null)
  const dispatch = useDispatch()

  const [displayedHoverEach, setDisplayedHoverEach] = React.useState(false)

  const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 })
  const [hoveredDay, setHoveredDay] = useState(null)
  const [additional, setAdditional] = useState(null)
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  useEffect(() => {
    if (token) {
      dispatch(getClients({ token }) as any)
      dispatch(getManagers({ token }) as any)
    }
  }, [dispatch, token])

  const [currentDate, setCurrentDate] = useState<{ month: string; year: number }>({
    month: monthsArr[monthNumber],
    year: new Date().getFullYear(),
  })

  useEffect(() => {
    const year = Number(yearsAndMonth.split('-')[0])
    const month = monthsArr[monthNumber]
    setCurrentDate({ month, year })
  }, [yearsAndMonth, monthNumber])

  const dummyData = (array: any) => {
    const newClaims = array.map((newClaim: ClaimsFromPlacesType) => {
      return {
        ...newClaim,
        requests: newClaim.requests.map((a) => {
          const startDate = Number(a.startDate.slice(8, 10))
          const finishDate = Number(a.endDate.slice(8, 10))
          const startTime = a.startDate.slice(11, 16)
          const endTime = a.endDate.slice(11, 16)
          return {
            ...a,
            startDate: startDate,
            endDate: finishDate,
            startTime: startTime,
            endTime: endTime,
            startStringDate: a.startDate,
            endStringDate: a.endDate,
          }
        }),
      }
    })

    return newClaims
  }

  const now = new Date()

  const navigate = useNavigate()

  const calendarMonthIndex = Number(yearsAndMonth.split('-')[1]) - 1

  let daysInMonth = getDaysInMonth(currentDate.year, calendarMonthIndex)

  const onNextMonth = () => {
    let newMonthNumber = monthNumber + 1
    let newYear = currentDate.year

    if (newMonthNumber > 11) {
      newMonthNumber = 0
      newYear += 1
    }

    setMonthNumber(newMonthNumber)
    setCurrentDate({ month: monthsArr[newMonthNumber], year: newYear })
    onCheckMonthHandler(monthsArr[newMonthNumber], String(newYear))
  }
  const onPrevMonth = () => {
    let newMonthNumber = monthNumber - 1
    let newYear = currentDate.year

    if (newMonthNumber < 0) {
      newMonthNumber = 11
      newYear -= 1
    }

    setMonthNumber(newMonthNumber)
    setCurrentDate({ month: monthsArr[newMonthNumber], year: newYear })
    onCheckMonthHandler(monthsArr[newMonthNumber], String(newYear))
  }

  const onChangeTypeOfCalendar = (checked: boolean) => {
    if (!checked) {
      setWeekMode(true)
      setDays(
        [...Array(daysInMonth)]
          .map((e, i) => i + now.getDate())
          .slice(0, daysInMonth - now.getDate() + 1),
      )
    } else {
      setWeekMode(false)
      setDays([...Array(daysInMonth)].map((e, i) => i + 1))
    }
  }

  const onNavigateToCurrentClaim = (id: number) => {
    navigate(`${PATH.claimCardPage}${id}`)
  }

  useEffect(() => {
    setDays([...Array(daysInMonth)].map((e, i) => i + 1))
  }, [daysInMonth])

  useEffect(() => {
    if (Array.isArray(claims) && Array.isArray(places)) {
      setPlatforms(dummyData(claims))
    } else {
      setPlatforms([])
    }
  }, [claims, places])

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const getStartDate = (day: number, platformName?: string, id?: number) => {
    const currentMonth = monthNumber
    const fullDate = new Date(currentDate.year, currentMonth, day)
    setStartDate(fullDate)
    setCreateClaimModal(true)
    setPlatformName(platformName as any)
    setPlatformId(id as any)
  }

  const formatTime = (date: string) => {
    const year = parseInt(date.slice(0, 4))
    const month = parseInt(date.slice(5, 7)) - 1
    const day = parseInt(date.slice(8, 10))

    return new Date(year, month, day)
      .toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' })
      .replace('/', '.')
  }

  useEffect(() => {
    setAdditional(
      places?.filter((place: any) => !platforms?.some((platform) => platform?.id === place?.id)),
    )
  }, [places, platforms])

  const getWeekDayShort = (year: number, month: number, day: number) => {
    const date = new Date(year, month, day)
    return ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'][date.getDay()]
  }

  const WeekDayWithDateCell: React.FC<{ weekDay: string; day: number }> = ({ weekDay, day }) => {
    const isWeekend = weekDay === 'ВС' || weekDay === 'СБ'

    return (
      <div className={`${styles.weekDayWithDateCell} ${isWeekend ? styles.weekend : ''}`}>
        <div className={styles.dayNumber}>{day}</div>
        <div className={`${styles.weekDay} ${isWeekend ? styles.weekend : ''}`}>{weekDay}</div>
      </div>
    )
  }

  const headerDays = React.useMemo(
    () =>
      days.map((day) => ({
        day,
        weekDay: getWeekDayShort(currentDate.year, monthNumber, day),
      })),
    [days, currentDate.year, monthNumber],
  )

  return (
    <div className={styles.claimTable}>
      <ClaimTableHeader
        selectPlatfrom={selectPlatfrom}
        weekMode={weekMode}
        fromCurrentPlatform={fromCurrentPlatform}
        yearsAndMonth={yearsAndMonth}
        currentDate={currentDate}
        onOpenClaimFilters={onOpenClaimFilters}
        onNextClickHandler={onNextMonth}
        onPrevClickHandler={onPrevMonth}
        onSwipeHandler={onChangeTypeOfCalendar}
      />
      <div className={styles.claimTableContent}>
        <div className={styles.leftBlock}>
          <div className={styles.platformEmptyItem}></div>
          {platforms
            .filter((platform: any) => !type || platform?.establishment?.id == type)
            .map((platform: any) => (
              <Tooltip key={platform?.id} text={platform?.name}>
                <div className={styles.platformItem} key={platform?.id}>
                  {platform?.name.length > 30
                    ? `${platform?.name.slice(0, 30)}...`
                    : platform?.name}
                </div>
              </Tooltip>
            ))}

          {additional &&
            (additional as any)
              .filter((item: any) => item.establishment)
              .map((item: any) => (
                <Tooltip key={item?.id} text={item?.name}>
                  <div className={styles.platformItem} key={item?.id}>
                    {item?.name.length > 30 ? `${item?.name.slice(0, 30)}...` : item?.name}
                  </div>
                </Tooltip>
              ))}
        </div>
        <div className={styles.rightBlock}>
          <div
            className={styles.headerRow}
            style={
              weekMode
                ? { gridTemplateColumns: `repeat(${days.length},minmax(160px, 1fr))` }
                : {
                    gridTemplateColumns: isMobile
                      ? `repeat(${days.length},minmax(40px, 1fr))`
                      : `repeat(${days.length},minmax(60px, 1fr))`,
                  }
            }
          >
            {headerDays.map(({ weekDay, day }, idx) => (
              <WeekDayWithDateCell key={idx} weekDay={weekDay} day={day} />
            ))}
          </div>
          <div
            className={styles.rightBlockContent}
            style={{
              gridTemplateRows: `repeat(${platforms?.length},40px)`,
            }}
          >
            {platforms
              .filter((platform: any) => places.some((place: any) => place?.id === platform?.id))
              .map((p: any, ind: number) => {
                let request: any
                const normalizedRequests = (p.requests || []).filter(
                  (requestItem: any, index: number, arr: any[]) => {
                    if (!requestItem) {
                      return false
                    }

                    const sameIdIndex = arr.findIndex((item: any) => item?.id === requestItem?.id)
                    if (sameIdIndex !== index) {
                      return false
                    }

                    const signature = `${requestItem.startStringDate}|${requestItem.endStringDate}|${requestItem.startTime}|${requestItem.endTime}|${requestItem.status}`
                    const sameSignatureIndex = arr.findIndex((item: any) => {
                      if (!item) {
                        return false
                      }
                      const itemSignature = `${item.startStringDate}|${item.endStringDate}|${item.startTime}|${item.endTime}|${item.status}`
                      return itemSignature === signature
                    })

                    return sameSignatureIndex === index
                  },
                )

                const rangeOfClaim: any = []
                const requestsWithRanges: any = []

                for (let i = 0; i < normalizedRequests.length; i++) {
                  if (
                    normalizedRequests[i].status !== 'canceled' &&
                    normalizedRequests[i].status !== 'rejected' &&
                    normalizedRequests[i].status !== 'unconfirmed'
                  ) {
                    let rangeItemOfClaim = fillingArray(
                      normalizedRequests[i].startDate,
                      normalizedRequests[i].endDate,
                      normalizedRequests[i]?.id,
                      calendarMonthIndex,
                      normalizedRequests[i].startStringDate,
                      normalizedRequests[i].endStringDate,
                      currentDate.year,
                    )
                    requestsWithRanges.push({
                      range: rangeItemOfClaim,
                      request: normalizedRequests[i],
                    })
                  }
                }

                const hasDateOverlap = (range1: any, range2: any) => {
                  const start1 = Math.min(...range1.range.arr)
                  const end1 = Math.max(...range1.range.arr)
                  const start2 = Math.min(...range2.range.arr)
                  const end2 = Math.max(...range2.range.arr)

                  return start1 <= end2 && start2 <= end1
                }

                for (let i = 0; i < requestsWithRanges.length; i++) {
                  let shouldAdd = true

                  for (let j = 0; j < requestsWithRanges.length; j++) {
                    if (i !== j && hasDateOverlap(requestsWithRanges[i], requestsWithRanges[j])) {
                      if (
                        requestsWithRanges[i].request.status === 'inAnticipation' &&
                        requestsWithRanges[j].request.status === 'inProgress'
                      ) {
                        shouldAdd = false
                        break
                      }
                    }
                  }

                  if (shouldAdd && requestsWithRanges[i].range.arr.length > 0) {
                    rangeOfClaim.push(requestsWithRanges[i].range)
                  }
                }

                const containsRequest = normalizedRequests.some(
                  (request: any) => request?.id === displayedHoverId,
                )
                const index = normalizedRequests.findIndex(
                  (request: any) => request?.id === displayedHoverId,
                )
                if (containsRequest) {
                  request = {
                    title: p.company.name,
                    platformName: p.name,
                    personCount: normalizedRequests[index].peopleCount,
                    startTime: normalizedRequests[index].startTime,
                    finishTime: normalizedRequests[index].endTime,
                    startDate: formatTime(normalizedRequests[index].startStringDate),
                    finishDate: formatTime(normalizedRequests[index].endStringDate),
                  }
                }

                const onMouseEnterHandler = (id: number) => {
                  setDisplayedHover(true)
                  setDisplayedHoverId(id)
                }

                const onMouseEnterHandlerEach = (id: number) => {
                  setDisplayedHoverEach(true)
                  setDisplayedHoverId(id)
                }

                const displayedTimeRequestIds = new Set<number | string>()

                return (
                  <div
                    key={ind}
                    className={styles.contentRowItem}
                    style={
                      weekMode
                        ? {
                            gridTemplateColumns: `repeat(${days.length},minmax(160px, 1fr))`,
                            cursor: 'pointer',
                          }
                        : {
                            gridTemplateColumns: isMobile
                              ? `repeat(${days.length},minmax(40px, 1fr))`
                              : `repeat(${days.length},minmax(60px, 1fr))`,
                            cursor: 'pointer',
                          }
                    }
                  >
                    <>
                      {days.map((d) => {
                        let resultBack = 'white'
                        let resultId: any = null
                        let matchingRequest: any = null
                        let isStartOfRange = false
                        let allSameDay: any
                        let matchingRequests: any = []
                        let ids: any = []
                        let startRange: any = null
                        let startRequest: any = null

                        rangeOfClaim.forEach((range: any) => {
                          for (let j = 0; j < range.arr.length; j++) {
                            allSameDay = []

                            if (range.arr[j] === d) {
                              const request = normalizedRequests.find(
                                (item: any) => item?.id === range?.id,
                              )
                              const statusBackground = createStyleForStatusTable(request?.status)

                              if (statusBackground === 'white') {
                                continue
                              }

                              resultBack = 'rgba(41, 40, 83, 1)'
                              resultId = range?.id
                              matchingRequest = request

                              if (matchingRequest.startDate == matchingRequest.endDate) {
                                allSameDay.push(j)
                                ids.push(matchingRequest?.id)
                              }
                              if (range.arr[0] === d) {
                                isStartOfRange = true
                                startRange = range
                                startRequest = request
                              }
                              matchingRequests.push(matchingRequest)
                            }
                          }
                        })
                        const uniqueMatchingRequests = matchingRequests.filter(
                          (req: any, index: number, arr: any[]) =>
                            arr.findIndex((item: any) => item?.id === req?.id) === index,
                        )
                        const allDatesAreSame = uniqueMatchingRequests.every(
                          (req: any) => req.startDate === req.endDate,
                        )
                        const shouldShowTimeLabel =
                          isStartOfRange &&
                          startRange &&
                          uniqueMatchingRequests.length > 0 &&
                          !displayedTimeRequestIds.has(startRange.id)

                        if (shouldShowTimeLabel) {
                          displayedTimeRequestIds.add(startRange.id)
                        }

                        const primaryRequest = startRequest ?? matchingRequest
                        const primaryId = primaryRequest?.id ?? null

                        return (
                          <div
                            onClick={() => !resultId && getStartDate(d, p.name, p?.id)}
                            className={styles.contentItem}
                            style={{
                              border: resultBack !== 'white' ? 'none' : '1px solid #E5E7EB',
                            }}
                            key={d}
                          >
                            {resultBack !== 'white' && primaryRequest && (
                              <div
                                onClick={() =>
                                  onNavigateToCurrentClaim(primaryId ? primaryId : null)
                                }
                                style={{
                                  background: createStyleForStatusTable(primaryRequest.status),
                                  position: 'relative',
                                  borderLeft: isStartOfRange ? '2px solid #ffffff' : undefined,
                                  ...(uniqueMatchingRequests.length > 1 && { zIndex: 2 }),
                                }}
                                onMouseEnter={(e: React.MouseEvent) => {
                                  e.stopPropagation()
                                  if (!(uniqueMatchingRequests.length > 1)) {
                                    setDisplayedHover(true)
                                  }
                                  if (displayedHoverEach) {
                                    setDisplayedHoverEach(false)
                                  }
                                  if (allDatesAreSame && uniqueMatchingRequests.length > 1) {
                                    onMouseEnterHandlerEach(primaryId ? primaryId : null)
                                  } else {
                                    onMouseEnterHandler(primaryId ? primaryId : null)
                                  }

                                  const x = e.clientX
                                  const y = e.clientY

                                  const screenWidth = window.innerWidth
                                  const popupWidth = 400

                                  let adjustedX = x - popupWidth

                                  if (adjustedX < 10) {
                                    adjustedX = x + 20
                                  }

                                  if (adjustedX + popupWidth > screenWidth - 10) {
                                    adjustedX = screenWidth - popupWidth - 10
                                  }

                                  const screenHeight = window.innerHeight
                                  const popupHeight = 200

                                  let adjustedY = y

                                  if (adjustedY + popupHeight > screenHeight - 10) {
                                    adjustedY = y - popupHeight - 20
                                  }

                                  if (adjustedY < 10) {
                                    adjustedY = 10
                                  }
                                  setHoverPosition({
                                    x: adjustedX,
                                    y: adjustedY,
                                  })

                                  setHoveredDay(d as any)
                                }}
                                onMouseLeave={(e: React.MouseEvent) => {
                                  if (
                                    !e.relatedTarget ||
                                    !(e.relatedTarget instanceof Node) ||
                                    !e.currentTarget.contains(e.relatedTarget)
                                  ) {
                                    setDisplayedHover(false)
                                    setDisplayedHoverEach(false)
                                  }
                                }}
                              >
                                {shouldShowTimeLabel && (
                                  <div className={styles.timeContainer}>
                                    {allDatesAreSame && uniqueMatchingRequests.length > 1 ? (
                                      <>
                                        <p>{uniqueMatchingRequests.length} брон.</p>
                                        {displayedHoverEach &&
                                          uniqueMatchingRequests.length > 1 &&
                                          ids.some((id: any) => id == displayedHoverId) && (
                                            <div
                                              className={styles.hoverPopupEach}
                                              style={{
                                                position: 'fixed',
                                                left: `${hoverPosition.x + 100}px`,
                                                top: `${hoverPosition.y}px`,
                                                zIndex: 1000,
                                              }}
                                              onMouseLeave={() => {
                                                setDisplayedHover(false)
                                              }}
                                            >
                                              {uniqueMatchingRequests.map((request: any) => (
                                                <div
                                                  key={request?.id}
                                                  className={styles.hoverPopupItem}
                                                  onClick={() =>
                                                    onNavigateToCurrentClaim(
                                                      request?.id ? request?.id : null,
                                                    )
                                                  }
                                                  onMouseEnter={() =>
                                                    onMouseEnterHandler(
                                                      request?.id ? request?.id : null,
                                                    )
                                                  }
                                                >
                                                  <div className={styles.hoverPopupTimeBlock}>
                                                    <div
                                                      className={styles.hoverPopupStartTimeBlock}
                                                    >
                                                      <img
                                                        className={styles.hoverPopupPointIcon}
                                                        src={calendarIcon}
                                                        alt='calendarIcon'
                                                      />
                                                      <div className={styles.hoverPopupText}>
                                                        {formatTime(request.startStringDate)}
                                                      </div>
                                                    </div>
                                                    <div>-</div>
                                                    <div
                                                      className={styles.hoverPopupFinishTimeBlock}
                                                    >
                                                      <img
                                                        className={styles.hoverPopupPointIcon}
                                                        src={calendarIcon}
                                                        alt='calendarIcon'
                                                      />
                                                      <div className={styles.hoverPopupText}>
                                                        {formatTime(request.endStringDate)}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className={styles.hoverPopupTimeBlock}>
                                                    <div
                                                      className={styles.hoverPopupStartTimeBlock}
                                                    >
                                                      <img
                                                        className={styles.hoverPopupPointIcon}
                                                        src={clockIcon}
                                                        alt='clockIcon'
                                                      />
                                                      <div className={styles.hoverPopupText}>
                                                        {request.startTime}
                                                      </div>
                                                    </div>
                                                    <div>-</div>
                                                    <div
                                                      className={styles.hoverPopupFinishTimeBlock}
                                                    >
                                                      <img
                                                        className={styles.hoverPopupPointIcon}
                                                        src={clockIcon}
                                                        alt='clockIcon'
                                                      />
                                                      <div className={styles.hoverPopupText}>
                                                        {request.endTime}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                      </>
                                    ) : (
                                      <>
                                        <p>{(startRequest ?? matchingRequest).startTime}</p>
                                        <p>{(startRequest ?? matchingRequest).endTime}</p>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )
                      })}
                      {displayedHover &&
                        normalizedRequests.some(
                          (request: any) => request?.id === displayedHoverId,
                        ) &&
                        (() => {
                          const currentRequest = normalizedRequests.find(
                            (request: any) => request?.id === displayedHoverId,
                          )
                          return (
                            <div
                              className={styles.hoverPopup}
                              style={{
                                position: 'fixed',
                                left: `${hoverPosition.x}px`,
                                top: `${hoverPosition.y}px`,
                                zIndex: 1000,
                              }}
                            >
                              <div className={styles.hoverPopupTimeBlock}>
                                <span className={styles.hoverField}>Дата и время начала</span>
                                <div className={styles.hoverPopupStartTimeBlock}>
                                  <div className={styles.hoverPopupText}>
                                    {formatTime(currentRequest?.startStringDate)}{' '}
                                    {currentRequest?.startTime}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.hoverPopupTimeBlock}>
                                <span className={styles.hoverField}>Дата и время окончания</span>
                                <div className={styles.hoverPopupFinishTimeBlock}>
                                  <div className={styles.hoverPopupText}>
                                    {formatTime(currentRequest?.endStringDate)}{' '}
                                    {currentRequest?.endTime}
                                  </div>
                                </div>
                              </div>
                              <div className={styles.hoverPopupTimeBlock}>
                                <span className={styles.hoverField}>Клиент</span>
                                <div className={styles.hoverPopupText}>
                                  {currentRequest.client?.fullName || 'Не указан'}
                                </div>
                              </div>
                              <div className={styles.hoverPopupTimeBlock}>
                                <span className={styles.hoverField}>Зал</span>
                                <div className={styles.hoverPopupText}>{p.name}</div>
                              </div>
                            </div>
                          )
                        })()}
                    </>
                  </div>
                )
              })}
            {additional &&
              (additional as any).map((placeItem: any) => {
                return (
                  <div
                    key={placeItem?.id}
                    className={styles.contentRowItem}
                    style={
                      weekMode
                        ? {
                            gridTemplateRows: 'repeat(1,40px)',
                            gridTemplateColumns: `repeat(${days.length},minmax(160px, 1fr))`,
                          }
                        : {
                            gridTemplateColumns: isMobile
                              ? `repeat(${days.length},minmax(40px, 1fr))`
                              : `repeat(${days.length},minmax(60px, 1fr))`,

                            gridTemplateRows: 'repeat(1,40px)',
                          }
                    }
                  >
                    {days.map((d) => {
                      let resultBack = 'white'
                      return (
                        <div
                          className={styles.contentItem}
                          style={{ border: resultBack !== 'white' ? 'none' : '1px solid #E5E7EB' }}
                          key={d}
                        >
                          <div
                            className={styles.claimItem}
                            style={{ background: resultBack }}
                            onClick={() => getStartDate(d, placeItem?.name, placeItem?.id)}
                          ></div>
                        </div>
                      )
                    })}
                  </div>
                )
              })}
          </div>
        </div>
      </div>
      <CustomModal visible={createClaimModal} setVisible={setCreateClaimModal}>
        <CreateClaim
          id={platformId}
          customer={user.fullName}
          platformName={platformName}
          startDate={startDate ? startDate : new Date()}
          onClickHandler={() => setCreateClaimModal(false)}
          client={clients}
        />
      </CustomModal>
    </div>
  )
}

export default ClaimTable
